import { render, staticRenderFns } from "./LocationIcon.vue?vue&type=template&id=4400f0ae"
import script from "./LocationIcon.vue?vue&type=script&lang=js"
export * from "./LocationIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports